export default __webpack_public_path__ + "4d174f5f879c31510e5bf42ccb48d709.png";